import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice';
import associadoReducer from './associadoSlice';
import codigoReducer from './codigoSlice';
import respostasDoSgaReducer from './respostasDoSgaSlice';
import cotacaoReducer from './cotacaoSlice';
import vistoriaReducer from './vistoriaSlice';
import checklistAcessoriosReducer from './checklistAcessoriosSlice';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  associado: associadoReducer,
  codigo: codigoReducer,
  respostasDoSga: respostasDoSgaReducer,
  cotacao: cotacaoReducer,
  vistoria: vistoriaReducer,
  /*
   * 🔴 O slice `checklist` SAIU na at-64 — era o bug **B7** de `12-bugs.md`.
   *
   * Ele guardava uma versão antiga do checklist de acessórios (chaves em
   * camelCase, `completed`) e **nenhum componente o lia**: o único importador em
   * todo o `src` era esta linha. Também não era limpo no logout nem no login, ao
   * contrário de todos os outros slices de fluxo — que é como o B7 foi achado.
   *
   * ⚠️ A chave `checklist` continua no `persist:root` de quem já usou o app: o
   * `combineReducers` emite **um aviso de dev** ("Unexpected key") na primeira
   * carga e a descarta. Mesmo desfecho da remoção do `produtoSlice` na at-29;
   * sem migração de persist.
   */
  checklistAcessorios: checklistAcessoriosReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
